import React from 'react'
import './App.css'
import Pages from './components/pages/Pages'

const App = () => {
  return (
    <>
      <Pages/>
    </>
    
  )
}

export default App